/* eslint-disable */
import { OktaAuth } from "@okta/okta-auth-js";

// const oktaDevConfig = {
//   issuer: "https://dev-3365428.okta.com/oauth2/default",
//   clientId: "0oa4zkgbo9qkBrgtO5d7",
// }

const oktaProdConfig = {
  issuer: process.env.VUE_APP_OAUTH_ISSUER,
  clientId: process.env.VUE_APP_OAUTH_CLIENTID
};

const OktaAuthRef = new OktaAuth({
  // ...oktaDevConfig,
  ...oktaProdConfig,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ["openid", "profile", "email"]
});

export default OktaAuthRef;
